// extracted by mini-css-extract-plugin
export default {"container":"pageNotFound_container__drIjs","gotohome":"pageNotFound_gotohome__1TENS","innerContainer":"pageNotFound_innerContainer__XS2Ea"};